import { render, staticRenderFns } from "./select.vue?vue&type=template&id=1a8fa7e6&"
import script from "./select.vue?vue&type=script&lang=ts&"
export * from "./select.vue?vue&type=script&lang=ts&"
import style0 from "./select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports